{
  "common.close": "ዕጸው",
  "common.athleteFallback": "ስፖርተኛ {id}",
  "splash.title": "{app} — ተንቀሳቓሲ ምስሊ ንጥፈታት",
  "splash.tagline": "ተንቀሳቓሲ ካርታ ንናትካ ሓበሬታ&nbsp;Strava",
  "splash.demo": "መርኣያ",
  "tab.query.title": "ካርታ {name}",
  "tab.query.heading": "ንጥፈታት ድለ፦",
  "tab.query.optDays": "ናይ ቀረባ መዓልታት",
  "tab.query.optActivities": "ናይ ቀረባ ንጥፈታት",
  "tab.query.optIds": "መለለዪ ንጥፈታት",
  "tab.query.optDates": "ክሊ ዕለታት",
  "tab.query.idsPlaceholder": "መለለዪ ንጥፈታት ኣብዚ ኣእቱ",
  "tab.query.after": "ካብ፦",
  "tab.query.before": "ክሳብ፦",
  "tab.query.autozoom": "ድሕሪ ምእታው ናብቲ ውጽኢት ብዓርሱ ኣጕልሕ <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> ድለ",
  "tab.query.createAccount": "ሕሳብ ፍጠር ከምኡውን/ወይ እቶ።",
  "tab.query.sports": "ስፖርትታት፦",
  "tab.query.allSports": "ኩሎም ስፖርትታት",
  "tab.query.sportsExcept": "ብዘይካ እዚኦም ኩሎም",
  "tab.query.sportsNone": "ሓንቲ እውን የለን",
  "tab.query.loadingSports": "ስፖርትታት ይጽዓን ኣሎ…",
  "tab.query.sportsFailed": "ስፖርትታት እዚ ካርታ ክጽዓን ኣይከኣለን",
  "tab.query.noSports": "ክሳብ ሕጂ ንጥፈት የለን",
  "tab.activities.title": "ዝረኣዩ ንጥፈታት",
  "tab.activities.clearSelection": "ምርጫ ኣጽሪ",
  "tab.activities.renderSelected": "ዝተመርጹ ኣርኢ",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> ናብ ምርጫ ኣጕልሕ",
  "tab.controls.title": "ቅጥዕታት ደርቢ",
  "tab.controls.timescale": "መለክዒ ግዜ <i>&tau;</i>",
  "tab.controls.timescaleHint": "ቅልጣፈ ምጽዋት",
  "tab.controls.period": "ዙረት <i>T</i>",
  "tab.controls.periodHint": "ንጥፈት ~ ሞዴል",
  "tab.controls.dotSize": "ዓቐን ነጥቢ",
  "tab.controls.pathWidth": "ስፍሓት መገዲ",
  "tab.controls.pathWidthHint": "ባዶ መገድታት ይሓብእ",
  "tab.controls.colors": "ሕብርታት",
  "tab.controls.colorsHint": "ሕብርታት ኣዙር",
  "tab.controls.shadows": "ጽላሎት",
  "tab.profile.loginTitle": "እቶ",
  "tab.profile.anonNote": "ናይ ገዛእ ርእስኻ ንጥፈታት ንምርኣይን ሕሳብ Heatflask ንምምሕዳርን ብStrava እቶ።",
  "tab.profile.loginLink": "ብStrava እቶ",
  "tab.profile.editOnStrava": "መግለጺኻ ኣብ Strava ኣመዓራሪ",
  "tab.profile.indexNote": "ንቅልጡፍ ምርካብ ጽማቕ ንጥፈታትካ ንዝርዝር።",
  "tab.profile.viewIndex": "ዝርዝር ርአ",
  "tab.profile.sharedMaps": "ዝተኻፈሉ ካርታታት",
  "tab.profile.sharedMapsNote": "ጠፊኡ፦ ኣብ Heatflask ንጥፈታትካ ዝርኢ ንስኻ ጥራይ ኢኻ። በሪሁ፦ ናይ ካርታኻ መላግቦ ዘለዎ ዝኾነ ሰብ ኣብ Strava ንህዝቢ ዝገበርካዮም ንጥፈታት ክርኢ ይኽእል። ብሕታዊ ንጥፈታትካ ብኽልቲኡ መንገዲ ናትካ ጥራይ ይተርፉ። <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">ብሕትውና ብኸመይ ይሰርሕ</a>",
  "tab.profile.logout": "ውጻእ",
  "tab.profile.deleteAccount": "ሕሳብ ደምስስ",
  "tab.profile.deleteConfirm": "ሕሳብ Heatflask ክትድምስስ ትደሊ ዶ?\n\nእዚ ዝተዘርዘሩ ንጥፈታትካ የወግድ፣ ከምኡውን Heatflask ናብ ሓበሬታ Strava ዘለዎ ፍቓድ ይስርዝ። ክምለስ ኣይከኣልን።",
  "tab.profile.languageHeading": "ቋንቋ",
  "tab.profile.languageAuto": "ብዓርሱ",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">ትርጉማት ንምእራም ወይ ሓደሽቲ ንምውሳኽ ሓግዙና!</a>",
  "tab.profile.unitsHeading": "መለክዒታት",
  "tab.profile.unitsAuto": "ብዓርሱ",
  "tab.profile.unitsMetric": "ሜትሪክ (ኪ.ሜ፣ ሜ)",
  "tab.profile.unitsImperial": "ኢምፔሪያል (ማይል፣ ጫማ)",
  "tab.profile.textSizeHeading": "ዓቐን ጽሑፍ",
  "tab.profile.textSmaller": "ኣንእስ",
  "tab.profile.textReset": "ልሙድ",
  "tab.profile.textLarger": "ኣዕቢ",
  "tab.profile.mapDefaultsHeading": "ናይ ካርታ ነባሪ ቅጥዕታት",
  "tab.profile.mapDefaultsNote": "መላግቦኡ ናይ ገዛእ ርእሱ ቅጥዕታት ዘይውስን ካርታ ኣብ እትኸፍተሉ ግዜ ኩሉ፣ በዚ መሰረታዊ ካርታ፣ ገጽ መሬትን ቅጥዕታት ደርብን ጀምር። እትካፈሎም መላግቦታት ግን ንስኻ እትርእዮ ብልክዕ የርእዩ።",
  "tab.profile.mapDefaultsSave": "ከም ነባሪ ቅጥዕታተይ ዓቅብ",
  "tab.profile.mapDefaultsForget": "ረስዕ",
  "tab.info.title": "ሓበሬታ",
  "tab.info.controlsHeading": "መቆጻጸሪታት",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ስሓብ",
  "tab.info.shiftDragDesc": "ኣብ ውሽጢ ሳንዱቕ ንጥፈታት ምረጽ። ኣብ ናይ ምንካእ መርኣያ፣ ቅድም <i class=\"hf-object-group\"></i> ንከእ፣ ድሕሪኡ ብሓንቲ ኣጻብዕ ስሓብ። እቲ መወዳእታ ዝተመርጸ ንጥፈት ዝርዝሩ የርኢ፣ ዝርዝር ንጥፈታት ድማ ናብኡ ይሸብለል።",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ስሓብ",
  "tab.info.ctrlDragDesc": "ካርታ ብ3D ኣዙርን ኣዘንብልን፣ ወይ ክልተ ኣጻብዕ ተጠቐም",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "ናይ ጎኒ ባር ክፈት ወይ ዕጸው",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "ዝሓለፈ ወይ ዝቕጽል ትር ናይ ጎኒ ባር",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "ናይ ጎኒ ባር ዕጸው",
  "tab.info.liveUrlHeading": "ህያው ኣድራሻ",
  "tab.info.liveUrlDesc": "ትርኢት ካርታን ቅጥዕታት ተንቀሳቓሲ ምስልን ኣብ ኣድራሻ እቲ ገጽ ይዕቀቡ፣ ስለዚ ዝኾነ ዝካፈልካዮ ሰብ ሓደ ዓይነት ትርኢት ይርኢ።",
  "tab.info.videoHeading": "ቪድዮ ምውጻእ",
  "tab.info.videoDesc": "እቲ <i class=\"hf-video-camera\"></i> መጠወቒ ነቲ ተንቀሳቓሲ ምስሊ ከም MP4 ይቐርጽ፦ ንከኦ፣ ነቲ ሳንዱቕ ኣብቲ እትደልዮ ክፋል ካርታ ኣስተኻኽሎ፣ ድሕሪኡ ንምቕራጽ ደጊምካ ንከእ። ሓደ ምሉእ ዙረት ይቕረጽ፣ ስለዚ እቲ ቪድዮ ብዘይ ምቁራጽ ይድገም፤ ካብ {max} ካልኢት (Strava ዝቕበሎ ዝነውሐ ቪድዮ) ዝነውሐ ዙረት ኣብ {max} ይቑረጽ።",
  "tab.info.contributeHeading": "ኣበርክት",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> ኣብ GitHub ደግፍ",
  "tab.info.contactsHeading": "ርክባት",
  "map.basemapAndTerrain": "መሰረታዊ ካርታን ገጽ መሬትን",
  "map.pauseAnimation": "ተንቀሳቓሲ ምስሊ ንግዜኡ ኣቋርጽ",
  "map.resumeAnimation": "ተንቀሳቓሲ ምስሊ ቀጽል",
  "capture.record": "ቪድዮ ቅረጽ (ዙረት {period} ካ.)",
  "capture.recordTruncated": "ቪድዮ ቅረጽ (ሓደ ዙረት {period} ካ. እዩ፤ እተን ቀዳሞት {max} ካ. ጥራይ ክቕረጻ እየን)",
  "capture.recordArea": "ኣብ ውሽጢ ሳንዱቕ ዘሎ ቦታ ቅረጽ",
  "capture.stop": "ምቕራጽ ኣቋርጽ",
  "capture.selectionTooSmall": "እቲ ምርጫ ኣዝዩ ንእሽቶ እዩ",
  "capture.saved": "{name} ተዓቂቡ ({size})",
  "capture.cancelled": "ምቕራጽ ተሰሪዙ",
  "capture.failed": "ምቕራጽ ኣይተዓወተን፦ {error}",
  "capture.loadingEncoder": "ኢንኮደር ይጽዓን ኣሎ…",
  "capture.waitingForMap": "ካርታ ክሳብ ዝጽዓን ይጽበ ኣሎ…",
  "capture.encoding": "ይቕየር ኣሎ… {percent}%",
  "capture.finalizing": "ይዛዘም ኣሎ…",
  "share.title": "ናይዚ ካርታ ሊንክ ኣካፍሉ",
  "share.copied": "ሊንክ ተቐዲሑ",
  "share.copiedUnshared": "ሊንክ ተቐዲሑ — ግን ካርታኹም ኣይተኻፈለን፣ ስለዚ ካልእ ሰብ ክኸፍቶ ኣይክእልን። ንምቕያሩ «ዝተኻፈሉ ካርታታት» ወልዑ።",
  "share.unshared": "ካርታኹም ኣይተኻፈለን፣ ስለዚ ካልእ ሰብ ነዚ ሊንክ ክኸፍቶ ኣይክእልን። ንምቕያሩ «ዝተኻፈሉ ካርታታት» ወልዑ።",
  "share.copyThis": "ነዚ ሊንክ ቅድሑ፦",
  "update.available": "ሓድሽ ስሪት Heatflask ቀሪቡ ኣሎ።",
  "update.reload": "ደጊምካ ጽዓን",
  "import.title": "የእቱ ኣሎ",
  "import.stop": "ኣቋርጽ",
  "import.stopping": "የቋርጽ ኣሎ…",
  "import.contacting": "ምስ Strava ይራኸብ ኣሎ…",
  "import.countOf": "ንጥፈታት፦ {received} ካብ {total}",
  "import.count": "ንጥፈታት፦ {received}",
  "import.waitStrava": "ብሰንኪ ደረት ምውራድ Strava ክሳብ {time} ደው ኢሉ ኣሎ። እዚ ገጽ ክፉት ግደፎ፤ ዳግማይ ምጽዓን ኣየቀላጥፎን።",
  "import.waitRationed": "ናይ ሎሚ ቅልጡፍ ምውራድ ተወዲኡ። እቲ ዝተረፈ ኣብ {time} ብቐስታ ክቕጽል እዩ። እዚ ገጽ ክፉት ግደፎ።",
  "import.dailyLimit": "ዕለታዊ ደረት ምውራድ Strava ተወዲኡ። ድሕሪ {time} እንደገና ፈትን።",
  "import.dailyRationed": "ናይ ሎሚ ግደ ምውራድካ ካብ Strava ተወዲኡ። ድሕሪ {time} እንደገና ፈትን።",
  "import.noActivitiesYet": "ኣካውንትካ ናይ Strava ክሳብ ሕጂ ዝኾነ ንጥፈት የብሉን። ኣብ Strava ሓደ መዝግብ ወይ ስቐል፣ ኣብዚ ክርአ እዩ።",
  "table.noActivities": "ንጥፈታት የለዉን",
  "table.untitled": "(ኣርእስቲ የብሉን)",
  "activities.pageTitle": "{app} — ዝርዝር ንጥፈታት",
  "activities.heading": "ዝርዝር ንጥፈታት",
  "activities.fetching": "ንጥፈታት የምጽእ ኣሎ...",
  "activities.rateLimit": "ደረት ሕቶታት Strava በጺሑ፤ ኣብ {time} ክቕጽል እዩ",
  "activities.noData": "ይቕሬታ፣ ሓበሬታ የለን &#128577;",
  "activities.colServerCache": "መገዲ ኣብ ሰርቨር ተዓቂቡ (Mongo)",
  "activities.colBrowserCache": "መገዲ ኣብዚ መርበብ ተዓቂቡ",
  "activities.cachedServer": "መገዲ {id} ኣብ ሰርቨር ተዓቂቡ ኣሎ",
  "activities.notCachedServer": "መገዲ {id} ኣብ ሰርቨር ኣይተዓቀበን",
  "activities.cachedBrowser": "መገዲ {id} ኣብዚ መርበብ ተዓቂቡ ኣሎ",
  "activities.notCachedBrowser": "መገዲ {id} ኣብዚ መርበብ ኣይተዓቀበን",
  "sport.AlpineSki": "ናይ ኣልፓይን ስኪ",
  "sport.BackcountrySki": "ናይ ገጠር ስኪ",
  "sport.Badminton": "ባድሚንተን",
  "sport.Basketball": "ኩዕሶ መሶብ",
  "sport.Canoeing": "ምቕዛፍ ታንኳ",
  "sport.Cricket": "ክሪኬት",
  "sport.Crossfit": "ክሮስፊት",
  "sport.Dance": "ሳዕስዒት",
  "sport.EBikeRide": "ጉዕዞ ኤሌክትሪክ ብሽክሌታ",
  "sport.Elliptical": "ኤሊፕቲካል",
  "sport.EMountainBikeRide": "ጉዕዞ ኤሌክትሪክ ብሽክሌታ ጎቦ",
  "sport.Golf": "ጎልፍ",
  "sport.GravelRide": "ጉዕዞ ጸጸር",
  "sport.Handcycle": "ናይ ኢድ ብሽክሌታ",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "ምንቅስቓስ ብእግሪ",
  "sport.IceSkate": "ምንሻፍ ኣብ በረድ",
  "sport.InlineSkate": "ኢንላይን ምንሻፍ",
  "sport.Kayaking": "ካያኪንግ",
  "sport.Kitesurf": "ካይትሰርፊንግ",
  "sport.MountainBikeRide": "ጉዕዞ ብሽክሌታ ጎቦ",
  "sport.NordicSki": "ኖርዲክ ስኪ",
  "sport.Padel": "ፓዴል",
  "sport.PhysicalTherapy": "ፊዚዮቴራፒ",
  "sport.Pickleball": "ፒክልቦል",
  "sport.Pilates": "ፒላተስ",
  "sport.Racquetball": "ራኬትቦል",
  "sport.Ride": "ጉዕዞ ብሽክሌታ",
  "sport.RockClimbing": "ምድያብ ከውሒ",
  "sport.RollerSki": "ሮለር ስኪ",
  "sport.Rowing": "ምቕዛፍ",
  "sport.Run": "ጉያ",
  "sport.Sail": "ጃልባ ሸራ",
  "sport.Skateboard": "ስኬትቦርድ",
  "sport.Snowboard": "ስኖውቦርድ",
  "sport.Snowshoe": "ጫማ በረድ",
  "sport.Soccer": "ኩዕሶ እግሪ",
  "sport.Squash": "ስኳሽ",
  "sport.StairStepper": "ማሽን መሳልል",
  "sport.StandUpPaddling": "ደው ኢልካ ምቕዛፍ",
  "sport.Surfing": "ሰርፊንግ",
  "sport.Swim": "ምሕማስ",
  "sport.TableTennis": "ኩዕሶ ጠረጴዛ",
  "sport.Tennis": "ቴኒስ",
  "sport.TrailRun": "ጉያ መንገዲ ዱር",
  "sport.Velomobile": "ቬሎሞባይል",
  "sport.VirtualRide": "ምናባዊ ጉዕዞ ብሽክሌታ",
  "sport.VirtualRow": "ምናባዊ ምቕዛፍ",
  "sport.VirtualRun": "ምናባዊ ጉያ",
  "sport.Volleyball": "ቮሊቦል",
  "sport.Walk": "ምኻድ ብእግሪ",
  "sport.WeightTraining": "ልምምድ ክብደት",
  "sport.Wheelchair": "ዊልቸር",
  "sport.Windsurf": "ዊንድሰርፊንግ",
  "sport.Workout": "ልምምድ",
  "sport.Yoga": "ዮጋ"
}
